import type {
  AssignTagDTO,
  CreateTagPayload,
  TagDTO,
  TemplateDTO,
  TemplateSortParams,
  TemplatesListResponse,
  UpdateTemplatePayload,
} from '@/types/messageTemplates';
import { ApiService } from './api.service';

class MessageTemplatesService extends ApiService {
  public async getTags(): Promise<TagDTO[]> {
    const response = await this.get<TagDTO[]>('/api/v1/admin/message/templates/tags');
    return response.data;
  }

  public async getTemplates(params?: {
    sort?: TemplateSortParams;
    cursor?: string;
    limit?: number;
  }): Promise<TemplatesListResponse> {
    const queryParams = new URLSearchParams();
    if (params?.sort) {
      queryParams.set('sortBy', params.sort.sortBy);
      queryParams.set('sortOrder', params.sort.sortOrder);
    }
    if (params?.cursor) queryParams.set('cursor', params.cursor);
    if (params?.limit) queryParams.set('limit', params.limit.toString());
    const query = queryParams.toString();
    const url = `/api/v1/admin/message/templates${query ? `?${query}` : ''}`;
    const response = await this.get<TemplatesListResponse>(url);
    return response.data;
  }

  public async createTag(payload: CreateTagPayload): Promise<TagDTO> {
    const response = await this.post<TagDTO>('/api/v1/admin/message/templates/tags', payload);
    return response.data;
  }

  public async deleteTag(id: string): Promise<void> {
    await this.delete(`/api/v1/admin/message/templates/tags/${id}`);
  }

  public async saveDraft(payload: TemplateDTO): Promise<TemplateDTO> {
    const response = await this.post<TemplateDTO>('/api/v1/admin/message/templates/draft', payload);
    return response.data;
  }

  public async getTemplateById(id: string): Promise<TemplateDTO> {
    const response = await this.get<TemplateDTO>(`/api/v1/admin/message/templates/${id}`);
    return response.data;
  }

  public async updateTemplate(id: string, payload: UpdateTemplatePayload): Promise<void> {
    await this.put(`/api/v1/admin/message/templates/${id}`, payload);
  }

  public async deleteTemplate(id: string): Promise<void> {
    await this.delete(`/api/v1/admin/message/templates/${id}`);
  }

  public async getTemplateTags(id: string): Promise<AssignTagDTO[]> {
    const response = await this.get<AssignTagDTO[]>(`/api/v1/admin/message/templates/${id}/tags`);
    return response.data;
  }
}

export const messageTemplatesService = new MessageTemplatesService();
